import { AlertPriority, AlertStatus } from '../../../api/services/lupp/fhm-alerts/dto.fhm.alerts';

export function mapPriorityToClass(priority: AlertPriority): string {
  switch (priority) {
    case AlertPriority.CRITICAL:
      return 'critical';
    case AlertPriority.HIGH:
      return 'high';
    case AlertPriority.MEDIUM:
      return 'medium';
    case AlertPriority.LOW:
      return 'low';
    default:
      return '';
  }
}

export function getPriorityBadgeColor(
  priority: string
): 'error' | 'warning' | 'informative' | 'success' | 'neutral' | 'brand' {
  switch (priority.toUpperCase()) {
    case 'CRITICAL':
    case 'HIGH':
      return 'error';
    case 'MEDIUM':
      return 'informative';
    case 'LOW':
      return 'warning';
    default:
      return 'neutral';
  }
}

export function getStatusBadgeColor(
  status: string
): 'error' | 'warning' | 'informative' | 'success' | 'neutral' | 'brand' {
  switch (status.toUpperCase()) {
    case 'OPEN':
      return 'error';
    case 'IN_PROGRESS':
      return 'warning';
    case 'RESOLVED':
      return 'success';
    case 'DISMISSED':
      return 'neutral';
    default:
      return 'neutral';
  }
}

export function formatStatus(status: AlertStatus | string): string {
  return String(status).replace('_', ' ');
}

export { AlertStatus };

export function mapStatusToClass(status: AlertStatus): string {
  const statusMap: Record<AlertStatus, string> = {
    [AlertStatus.OPEN]: 'open',
    [AlertStatus.IN_PROGRESS]: 'inProgress',
    [AlertStatus.RESOLVED]: 'resolved',
    [AlertStatus.DISMISSED]: 'dismissed',
  };
  return statusMap[status];
}
